// extracted by mini-css-extract-plugin
export default {"img":"Loader_img__XaO65","pulsate":"Loader_pulsate__tB8p3"};